import api from 'store/services/api';

export interface LoginRequest {
  username: string;
  password: string;
}

export const loginService = (data: LoginRequest) =>
  api('/api/v1/auth/jwt/', {method: 'post', data});
